<script setup lang="ts">
import { close } from '@/components/icons/icons';
import { useNotificationStore } from '@/stores/notificationStore';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useTheme } from 'vuetify';

const notificationStore = useNotificationStore();
const { currentBarMessage: message } = storeToRefs(notificationStore);

const theme = useTheme();
const colors = computed(() => theme.current.value.colors);

const onClickAction = () => {
  if (typeof message.value?.actionForNotification?.action === 'function') {
    message.value?.actionForNotification?.action();
  }
  notificationStore.hideBarMessage();
};
</script>

<template>
  <Transition name="notificationBar">
    <span
      v-if="!!message"
      class="notification-bar"
      :style="{ backgroundColor: colors[message.type] }"
      :type="message.type"
    >
      <span class="text-body-2 message" @click="notificationStore.hideBarMessage()">
        <v-icon class="mr-2">{{ message.icon }}</v-icon>
        {{ message.message }}
        <span
          v-if="!!message.actionForNotification"
          class="ml-2 linkButton"
          @click.stop="onClickAction"
          >{{ message.actionForNotification?.actionTitle || '' }}
        </span>
      </span>
      <v-btn
        v-if="message?.type === 'error'"
        size="24"
        class="mr-2"
        small
        variant="text"
        rounded="0"
        @click.prevent="notificationStore.hideBarMessage()"
      >
        <v-icon color="off-white" size="24">{{ close }}</v-icon>
      </v-btn>
    </span>
  </Transition>
</template>

<style lang="scss" scoped>
.notification-bar {
  padding: 0;
  margin: 0;
  display: flex;
  flex-grow: 1;
  align-items: center;
  height: 40px;
  z-index: 999;
  color: rgba(var(--v-theme-surface));
}

.message {
  flex: 1;
  text-align: center;
}

.notificationBar-enter-active,
.notificationBar-leave-active {
  transition: ease-in 0.2s;
}
.notificationBar-enter-from,
.notificationBar-leave-to {
  transition: ease-out 0.5s;
  opacity: 0;
}
</style>
